export { default } from "./CartHeader";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/cartTable/cartHeader/index.js